import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import moment from 'moment'
import i18n from '@/libs/i18n'

export default function useTreatmentsList() {
  const refTreatmentListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', label: '#', sortable: false },
    { key: 'behandlung', label: i18n.t('Treatment'), sortable: false },
    { key: 'kundName', label: i18n.t('Customer'), sortable: false },
    { key: 'mitarbeiterName', label: i18n.t('Employee'), sortable: false },
    { key: 'preis', label: i18n.t('Price'), sortable: false, formatter: val => `CHF ${parseFloat(val).toFixed(2)}` },
    {
      key: 'total_preis',
      label: i18n.t('Total Price'),
      sortable: false,
      formatter: val => `CHF ${parseFloat(val).toFixed(2)}`
    },
    { key: 'behandlungsdatum', label: i18n.t('Treatment Date'),sortable: false, formatter: val => moment(String(val)).format('DD.MM.YYYY') },
    { key: 'updated_at', label: i18n.t("Updated At"), sortable: false, formatter: val => moment(String(val)).format('DD.MM.YYYY hh:mm:ss') },
    //{ key: 'actions', label: i18n.t("Actions") }, 
  ]

  const perPage = ref(10)
  const totalTreatments = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refTreatmentListTable.value ? refTreatmentListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTreatments.value,
    }
  })

  const refetchData = () => {
    refTreatmentListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery], () => {
    refetchData()
  })

  const fetchTreatments = (ctx, callback) => {
    store
      .dispatch('app-treatment/fetchTreatments', {
        //q: searchQuery.value,
        search_terms: searchQuery.value,
        size: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then(response => {
        const responseData = response.data

        callback(responseData.data)
        totalTreatments.value = responseData.meta.total
      })
      .catch(() => {
        // toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: 'Error fetching treatments list',
        //     icon: 'AlertTriangleIcon',
        //     variant: 'danger',
        //   },
        // })
      })
  }

  return {
    fetchTreatments,
    tableColumns,
    perPage,
    currentPage,
    totalTreatments,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refTreatmentListTable,
    refetchData,
  }
}